export default "__VITE_ASSET__CDj9Orjt__"